
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EventBus } from '@/main';
import { copyShopifyShareLink } from '@/utils/shopifyShareLink';

@Component
export default class CopyLinkButton extends Vue {
  @Prop({ default: true }) public xSmall!: boolean;
  @Prop({ default: false }) public small!: boolean;
  @Prop({ default: '' }) public color!: string;

  public async copyCurrentLink() {
    const ok = await copyShopifyShareLink(this.$route.fullPath);
    if (ok) {
      EventBus.$emit('show-snackbar', 'Link is copied');
    } else {
      EventBus.$emit('show-snackbar', {
        message: 'Failed to copy link',
        color: 'error',
      });
    }
  }
}
